const styles = {
  icon: {
    height: 24,
    width: 24,
  }
};

export default styles;